<template>
    <b-container style="margin-top:40px">
        <b-row class="m-0 justify-content-between">
            <b-col cols="auto">
                <div>
                    <h1 style="font-size: 24px;">Gestión de Banners</h1>
                    <p>Administra los banners del carrusel de anuncios del dashboard.</p>
                </div>
            </b-col>
            <b-col cols="auto">
                <b-button variant="primary" @click="$refs.bannerForm.show()">Nuevo Banner</b-button>
            </b-col>
        </b-row>
        <div class="tabla sombra">
            <b-table :fields="fields" :items="banners" :busy="loading" show-empty
                empty-text="No hay banners creados aún.">
                <template #table-busy>
                    <div class="text-center my-3">
                        <b-spinner variant="primary" />
                    </div>
                </template>
                <template #cell(bg)="{ value }">
                    <div class="color-preview"
                        :style="{ background: `linear-gradient(to right, ${value}, color-mix(in srgb, ${value} 80%, white))` }">
                    </div>
                </template>
                <template #cell(title)="{ value }">
                    <b>{{ value }}</b>
                </template>
                <template #cell(active)="{ item }">
                    <b-badge :variant="item.active ? 'success' : 'danger'" style="cursor: pointer"
                        @click="toggleActive(item)">
                        {{ item.active ? 'Activo' : 'Inactivo' }}
                    </b-badge>
                </template>
                <template #cell(actions)="{ item }">
                    <div class="table__actions">
                        <i class="material-icons" @click="$refs.bannerForm.show(item)">edit</i>
                        <i class="material-icons" @click="onDelete(item)">delete</i>
                    </div>
                </template>
            </b-table>
        </div>
        <BannerForm ref="bannerForm" @submit="onSubmit" />
    </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import BannerForm from '@/components/dashboard/BannerForm.vue';

export default {
    name: 'BannerManagementView',
    components: {
        BannerForm
    },
    data() {
        return {
            loading: false,
            fields: [
                { key: 'bg', label: 'Color' },
                { key: 'title', label: 'Título' },
                { key: 'description', label: 'Descripción' },
                { key: 'active', label: 'Estado' },
                { key: 'actions', label: 'Acciones' }
            ]
        }
    },
    computed: {
        ...mapGetters(['banners'])
    },
    created() {
        this.loadBanners();
    },
    methods: {
        async loadBanners() {
            this.loading = true;
            await this.$store.dispatch('fetchBanners');
            this.loading = false;
        },
        async onSubmit(banner) {
            if (banner.id) {
                await this.$store.dispatch('updateBanner', { id: banner.id, data: banner });
            } else {
                await this.$store.dispatch('createBanner', { data: banner });
            }
            this.$refs.bannerForm.hide();
            this.loadBanners();
        },
        async toggleActive(item) {
            await this.$store.dispatch('updateBanner', {
                id: item.id,
                data: { active: !item.active }
            });
            this.loadBanners();
        },
        async onDelete(item) {
            const confirmed = await this.$bvModal.msgBoxConfirm(
                `¿Estás seguro de que deseas eliminar el banner "${item.title}"?`,
                { title: 'Confirmar eliminación', okVariant: 'danger', okTitle: 'Eliminar', cancelTitle: 'Cancelar' }
            );
            if (confirmed) {
                await this.$store.dispatch('deleteBanner', { id: item.id });
                this.loadBanners();
            }
        }
    }
}
</script>

<style scoped>
.table__actions {
    display: flex;
    gap: 4px;
}

.table__actions i {
    cursor: pointer;
    color: #969696;
    padding: 5px;
    border-radius: 5px;
    transition: all 0.1s ease;
}

.table__actions i:hover {
    background-color: #d8d8d8;
    color: #fff;
}

.color-preview {
    width: 60px;
    height: 28px;
    border-radius: 5px;
}
</style>
